// src/features/audit/components/AuditTimelineCard.tsx
import { Card } from '../../../app/components/foundation';
import type { AuditTimelineEvent } from '../data/audit.mock';

export interface AuditTimelineCardProps {
  timeline: AuditTimelineEvent[];
}

/**
 * Workspace card: chronological timeline for this audit record (info,
 * action, alert, system events). Same markup/CSS pattern as
 * customers/components/CustomerActivityCard.tsx,
 * orders/components/OrderTimelineCard.tsx, and
 * security/components/SecurityTimelineCard.tsx — dot markers colored
 * by event type, event title, timestamp, and description. No new UI
 * pattern introduced.
 */
export function AuditTimelineCard({ timeline }: AuditTimelineCardProps) {
  return (
    <Card className="vania-audit-workspace-card">
      <h2 className="vania-audit-workspace-card-title">تاریخچه رخداد</h2>

      {timeline.length === 0 ? (
        <p className="vania-audit-workspace-empty">رویدادی برای این رخداد ثبت نشده است.</p>
      ) : (
        <ol className="vania-audit-workspace-timeline">
          {timeline.map((event) => (
            <li key={event.id} className="vania-audit-workspace-timeline-item">
              <span
                aria-hidden
                className={`vania-audit-workspace-timeline-dot vania-audit-workspace-timeline-dot-${event.type}`}
              />
              <div className="vania-audit-workspace-timeline-body">
                <span className="vania-audit-workspace-timeline-type">{event.title}</span>
                <span className="vania-audit-workspace-list-secondary">{event.description}</span>
                <span className="vania-audit-workspace-timeline-date">{event.date}</span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
